<template>
  <v-main
    v-if="building"
    >
    <v-snackbar
      v-model="success"
      color="success"
      class="font-weight-medium"
      >
      <div
        class="text-center fill-width"
        >
        ¡Actualización realizada con éxito!
      </div>
    </v-snackbar>

    <v-container
      fluid
      class="pa-0"
      >
      <div class="white px-8 py-5 d-flex flex-row justify-space-between align-center">
        <div
          class="d-flex fill-width align-center"
          >
          <go-back 
            class="shrink pr-3"
            ></go-back>
          <h2 class="my-2">{{ building.fullAddress }}</h2>
        </div>
      </div>

      <div
        class="pa-3 d-flex flex-row"
        style="gap: 24px"
        >
        <properties
          :building="building"
          @reload="fetchBuilding"
          ></properties>

        <taxes
          :building="building"
          ></taxes>
      </div>
    </v-container>
  </v-main>
</template>

<script>
import { Building } from '@/graphql/queries/buildings'
import { EditCommonExpense } from '@/graphql/mutations/buildings'
import GoBack from '@/components/GoBack'
import Properties from '@/components/buildings/Properties'
import Taxes from '@/components/buildings/Taxes'

export default {
  data: () => ({
    amount: null,
    success: false,
    building: null,
    taxes: [],
  }),

  created () {
    this.fetchBuilding ()
  },

  methods: {
    fetchBuilding () {
      this.$apollo.query({
        query: Building,
        variables: {
          id: this.$route.params.id
        },
        fetchPolicy: 'no-cache'
      }).then ( res => {
        this.building = res.data.building
      })
    },
  },

  components: {
    GoBack,
    Properties,
    Taxes
  }
}
</script>
